import ResultsPageDisplay from './ResultsPageDisplay';

export default ResultsPageDisplay;
